import React from 'react';

export const BlogHomeHeroSection = () => {
  return (
    <section className="w-full bg-white overflow-hidden px-4 pt-10 md:pt-20">
      <div className="max-w-5xl mx-auto">
        <h1 className="font-sans text-3xl md:text-5xl font-medium text-black -tracking-[0.03em] mb-8">
          Blog
        </h1>
        <p className="font-sans text-lg md:text-2xl text-black -tracking-[0.02em]">
          Insights on transforming and scaling sales expertise with AI agents
        </p>
        <hr className="border-b border-gray-200 mt-16" />
      </div>
    </section>
  );
}